import { render, staticRenderFns } from "./testPaper.vue?vue&type=template&id=ff2f8cec&scoped=true"
import script from "./testPaper.vue?vue&type=script&lang=js"
export * from "./testPaper.vue?vue&type=script&lang=js"
import style0 from "./testPaper.vue?vue&type=style&index=0&id=ff2f8cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f8cec",
  null
  
)

export default component.exports